/** Site-wide gold gradient (replaces solid orange CTAs). */
export const GOLD_FROM = '#F6CB86'
export const GOLD_TO = '#E0A263'

/** Shared corner radius for primary / secondary CTAs site-wide. */
export const ctaRadius = 'rounded-[28px]'

/** Tailwind-friendly classes: gradient fill + black label + gold-tinted glow */
export const goldGradientButton = `${ctaRadius} bg-gradient-to-r from-[#F6CB86] to-[#E0A263] text-black font-semibold shadow-[0_0_0_1px_rgba(246,203,134,0.45)] shadow-[0_6px_28px_-6px_rgba(224,162,99,0.42)] transition hover:brightness-[1.03] active:brightness-[0.98]`

/** Smaller shadow variant */
export const goldGradientButtonSm = `${ctaRadius} bg-gradient-to-r from-[#F6CB86] to-[#E0A263] text-black font-semibold shadow-[0_0_0_1px_rgba(246,203,134,0.4)] shadow-[0_4px_20px_-4px_rgba(224,162,99,0.35)] transition hover:brightness-[1.03] active:brightness-[0.98]`

/** Hero primary CTA — flat gradient, no drop shadow */
export const goldGradientButtonHero = `${ctaRadius} bg-gradient-to-r from-[#F6CB86] to-[#E0A263] text-black font-semibold shadow-none transition hover:brightness-[1.03] active:brightness-[0.98]`

/** Text that uses the same gradient (no separate fill) */
export const goldGradientText =
  'bg-gradient-to-r from-[#F6CB86] to-[#E0A263] bg-clip-text text-transparent'

/** Icon chip: gradient fill + black icon */
export const goldGradientIconChip =
  'border border-[#F6CB86]/35 bg-gradient-to-br from-[#F6CB86] to-[#E0A263] text-black shadow-[0_0_0_1px_rgba(246,203,134,0.25)] shadow-[0_4px_16px_-4px_rgba(224,162,99,0.35)]'

/** Industry / status / trending pills on cards — brand gold at reduced opacity. */
export const brandTagPill =
  'bg-[#F6CB86]/10 text-[#8a5e1a] ring-1 ring-[#E0A263]/40 dark:text-[#F6CB86]/78 dark:ring-[#E0A263]/22'

/** Hover affordance for clickable tag pills (e.g. industry). */
export const brandTagPillInteractive =
  'hover:bg-[#F6CB86]/15 hover:text-[#6f4a14] hover:ring-[#E0A263]/55 dark:hover:text-[#F6CB86]/92 dark:hover:ring-[#E0A263]/32'

/**
 * Outline / secondary buttons: transparent fill; hover only darkens the border
 * (no background fill on hover).
 */
export const outlineButton =
  'border border-[color:var(--btn-outline-border)] bg-transparent text-[var(--foreground)] transition hover:border-[color:var(--btn-outline-border-hover)] hover:bg-transparent'

/** Same as outlineButton with common CTA radius + padding. */
export const outlineButtonCta = `${outlineButton} inline-flex items-center justify-center ${ctaRadius} px-4 py-2 text-sm font-semibold`
